import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Div } from '../../layouts';
import { ArrivalDesktop, DepartureDesktop } from './DesktopFields';
import { SwapButtonDesktop } from './Segment/SwapButton';
import { getActiveProduct, getConfig } from '../../redux/currentSearch/selectors';
import { ConfigProp, ConfigPropDefault, EntryPoint } from '../../models';
import { ClickTrackDPArrival, ClickTrackDPDeparture } from '../HotelManager/SearchFormFieldsClickableWrapper';

export const FlightsManagerLegDesktop = ({
    activeProduct,
    fieldFocused,
    onChangeFocus,
    config,
}) => {
    const shouldShowSwap = config?.swapButton.visible;
    const handleFocusChange = (departureOrArrival, focus) => {
        onChangeFocus(departureOrArrival, focus);
    };
    const ClickTrackDeparture = activeProduct === EntryPoint.DP ? ClickTrackDPDeparture : Fragment;
    const ClickTrackArrival = activeProduct === EntryPoint.DP ? ClickTrackDPArrival : Fragment;

    return (
        <>
            <div className="odf-col odf-col-top">
                <ClickTrackDeparture>
                    <DepartureDesktop
                        fieldFocused={fieldFocused}
                        onChangeFocus={handleFocusChange}
                    />
                </ClickTrackDeparture>
            </div>
            <Div
                className="odf-col odf-col-top"
                position="relative"
            >
                { shouldShowSwap && (
                    <SwapButtonDesktop />
                )}
                <ClickTrackArrival>
                    <ArrivalDesktop
                        fieldFocused={fieldFocused}
                        onChangeFocus={handleFocusChange}
                    />
                </ClickTrackArrival>
            </Div>
        </>
    );
};

FlightsManagerLegDesktop.propTypes = {
    onChangeFocus: PropTypes.func.isRequired,
    fieldFocused: PropTypes.string,
    config: ConfigProp.isRequired,
};
FlightsManagerLegDesktop.defaultProps = {
    fieldFocused: null,
    config: ConfigPropDefault,
};

const mapStateToPropsSelector = createStructuredSelector({
    activeProduct: getActiveProduct,
    config: getConfig
});

export const ConnectedFlightsManagerLegDesktop = connect(mapStateToPropsSelector, {})(FlightsManagerLegDesktop);
